import { render } from "./DoGooderModal.vue?vue&type=template&id=5dbb631e"
import script from "./DoGooderModal.vue?vue&type=script&lang=js"
export * from "./DoGooderModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__